import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useWhatsAppPhonePrompt } from "@/hooks/useWhatsAppPhonePrompt";
import { Loader2 } from "lucide-react";

interface WhatsAppPhoneGateProps {
  children: React.ReactNode;
}

export function WhatsAppPhoneGate({ children }: WhatsAppPhoneGateProps) {
  const { shouldShow, isChecking } = useWhatsAppPhonePrompt();
  const { user } = useAuth();

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (shouldShow) {
    return (
      <Navigate to="/verify-email" replace state={{ email: user?.email, role: "fan" }} />
    );
  }

  return <>{children}</>;
}
